<lib-base [isSubPage]="isSubPage">
  <router-outlet></router-outlet>
</lib-base>
